// Uploads are downscaled and re-encoded (mobile always, web over
// UPLOAD_IMAGE_MAX_BYTES) so they stay well under the Storage write rule for
// uploads/goal and uploads/vision (`request.resource.size < 5 MB`, backend repo
// storage/security.rules). A write over it is denied with a 403.
export const UPLOAD_IMAGE_MAX_EDGE = 2000;
export const UPLOAD_IMAGE_JPEG_QUALITY = 0.75;
// The lower of 5 MB and 5 MiB, so a file under this passes the rule either way.
export const UPLOAD_IMAGE_MAX_BYTES = 5_000_000;

export type UploadImageSize = {
  width: number;
  height: number;
};

export const getUploadImageSize = ({
  width,
  height,
}: UploadImageSize): UploadImageSize => {
  const longestEdge = Math.max(width, height);

  if (longestEdge <= UPLOAD_IMAGE_MAX_EDGE) {
    return { width, height };
  }

  const scale = UPLOAD_IMAGE_MAX_EDGE / longestEdge;
  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale)),
  };
};
